import { translateError } from "../../../../constants/errorMessages.ts";
import type { LifecycleController, Notice } from "../useLifecycle.ts";
export function NoticeBox({ notice }: { notice: Notice }) {
  const style =
    notice.kind === "success"
      ? "border-success/30 bg-success/10 text-success"
      : notice.kind === "warning"
      ? "border-warning/40 bg-warning/10 text-warning"
      : "border-danger/30 bg-danger/10 text-danger";
  return (
    <div
      role={notice.kind === "error" ? "alert" : "status"}
      className={`rounded-sm border p-3 text-sm ${style}`}
    >
      <p>{notice.text}</p>
      {notice.detail && (
        <details className="mt-2 text-xs">
          <summary>Технически подробности</summary>
          <p>{notice.detail}</p>
        </details>
      )}
    </div>
  );
}
export function Feedback({ controller }: { controller: LifecycleController }) {
  const { error, notice, operationState: state, lookupError } = controller;
  return (
    <>
      {error && (
        <NoticeBox
          notice={{
            kind: "error",
            text: translateError(error.code, error.message).text,
            detail: [
              error.code,
              error.message,
              ...error.fields.map(
                (field) => `${field.field}: ${field.message ?? field.code}`
              ),
            ].join("\n"),
          }}
        />
      )}
      {!error && Boolean(state.error) && (
        <NoticeBox
          notice={{
            kind: "error",
            text: "Възникна грешка при заявката.",
            detail:
              state.error instanceof Error
                ? state.error.message
                : String(state.error),
          }}
        />
      )}
      {notice && <NoticeBox notice={notice} />}
      {Boolean(lookupError) && (
        <NoticeBox
          notice={{
            kind: "error",
            text: "Неуспешно зареждане на възможностите или данните за осчетоводяване. Проверете избраните офис и агент.",
          }}
        />
      )}
    </>
  );
}
